/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntegrationEventCategoryResponse = {
    id: number;
    name: string;
    description: string | null;
    color: string;
    duration: number;
    price: string;
    location: IntegrationEventCategoryResponse.location;
    currency: IntegrationEventCategoryResponse.currency;
    publicBookingEnabled: boolean;
    privateBookingEnabled: boolean;
};
export namespace IntegrationEventCategoryResponse {
    export enum location {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
        NOT_FIXED = 'not-fixed',
    }
    export enum currency {
        EUR = 'EUR',
        CHF = 'CHF',
    }
}

